import React from "react";

export default function EmptyStateTricho() {
  return (
    <div className="tricho-empty">
      <div className="tricho-empty__icon">📷</div>
      <div className="tricho-empty__title">Selecione uma imagem para começar</div>
      <div className="tricho-empty__subtitle">
        Depois, marque as unidades foliculares (simples/duplas/triplas) ou rode a IA.
      </div>
      <div className="tricho-empty__tip">
        Dica: fotos bem iluminadas e foco nítido melhoram a marcação.
      </div>
    </div>
  );
}
